import { useRoutes } from "react-router-dom";
import PublicRouters from "./public";
import ClientRouters from "./client";
import useAuth from "../context/auth";
import { Loading } from "./loading";
import DefaultRouters from "./default";
import PartnerRouters from "./partner";



const Routes = (): JSX.Element => {
    const { isAuthenticated, user } = useAuth();

    const routes = isAuthenticated === null
        ? [{ path: "*", element: <Loading /> }]
        : isAuthenticated
            ? [...DefaultRouters, ...(user?.role === 5 ? ClientRouters : []), ...(user?.role === 20 ? PartnerRouters : [])]
            : [...DefaultRouters, ...PublicRouters];

    return useRoutes(routes) || <Loading />;
};

export default Routes;
